import type {
  InsertTagTypeGroupByNameMutation,
  InsertTagTypeGroupByNameMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

const mapTrpcResponseToGraphQL = (trpcData: {
  Id: string;
}): InsertTagTypeGroupByNameMutation => {
  return {
    insert_tag_type_group_one: {
      __typename: 'tag_type_group',
      Id: trpcData.Id,
    },
  };
};

export const useInsertTagTypeGroupByNameTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.tag.insertTagTypeGroup.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.tag.pathKey(),
        });
      },
    }),
  });

  return {
    insertTagTypeGroup: async (
      variables: InsertTagTypeGroupByNameMutationVariables
    ): Promise<InsertTagTypeGroupByNameMutation> => {
      const result = await mutation.mutateAsync({
        Name: variables.Name ?? '',
      });

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
